import { createFileRoute, stripSearchParams } from '@tanstack/react-router';

import { DeliveryChangesPage } from '~/modules/deliveryChanges';

import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';
import { getRouteHead } from '~/utils/routeUtils';

import { routeParams, searchDefaults, validateSearch } from './-routeParams';

const title = i18n.t(($) => $.pageTitle.recentChanges, { ns: 'delivery' });

export const Route = createFileRoute('/(main)/deliveries/recent-changes/')({
  beforeLoad: createProtectedRoute({
    routePath: '/deliveries/recent-changes/',
    ...routeParams,
  }),
  component: DeliveryChangesPage,
  head: () => getRouteHead(title),
  search: {
    middlewares: [stripSearchParams(searchDefaults)],
  },
  staticData: {
    AppBar: {
      title,
    },
  },
  validateSearch,
});

export const DELIVERY_RECENT_CHANGES = buildRouteExport({
  Route,
  ...routeParams,
});
